/**
 * POS "modo moderno" (/app/vender-pro). Apagado por decisión del dueño (28/09/2026):
 * se arranca con un solo POS, el del menú (/app/ventas/vender). El código se mantiene
 * (no borrarlo, ver tarea 126): con true vuelve el botón "Modo Moderno" y la ruta.
 */
export const POS_MODERNO_ACTIVO = false;
